// extracted by mini-css-extract-plugin
export var content = "_pd-1";
export var fullScreen = "_pd-0";